import React from 'react';
import { TestimonialsSection } from './TestimonialsSection';
const data = [{
  initials: 'AL',
  quote: 'No es un libro más. Es tiempo real con mis hijos. Cada cita es un momento que atesoramos.',
  name: 'Andrea L.',
  location: 'Santa Fe',
  role: 'Mamá de adolescente'
}, {
  initials: 'RG',
  quote: 'Mis hijos ahora me buscan para hacer las citas. Antes era al revés. Eso no tiene precio.',
  name: 'Roberto G.',
  location: 'Rosario',
  role: 'Papá de 3 hijos'
}, {
  initials: 'VP',
  quote: 'Lo mejor es que no necesitás planificar nada. Abrís el libro, elegís una cita y listo.',
  name: 'Valeria P.',
  location: 'Tucumán',
  role: 'Mamá de familia'
}, {
  initials: 'DM',
  quote: 'Nos cambió la dinámica familiar. Ahora tenemos nuestro momento sagrado cada día.',
  name: 'Diego M.',
  location: 'Mendoza',
  role: 'Papá de 2 hijos',
  highlight: 'Pack Completo'
}];
export function Testimonials2() {
  return <TestimonialsSection title="❤️ MÁS FAMILIAS CREANDO RECUERDOS" testimonials={data} darker data-id="element-240" />;
}